import { useEffect, useState } from "react";

export const useOverflow = (
  ref: React.RefObject<HTMLElement | null>,
  deps: any[] = []
) => {
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (ref.current) {
      const { scrollWidth, clientWidth } = ref.current;
      setIsOverflowing(scrollWidth > clientWidth);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, ...deps]);

  return isOverflowing;
};
